import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { JobService } from 'src/@core/services/job/job.service';
import { ACTIVATE_PHONE_NUMBER, PURCHASE_PHONE_NUMBER } from 'src/@core/services/util/api.endpoints';
import { environment } from 'src/environments/environment';

declare var Razorpay: any;

@Component({
  selector: 'hour4u-admin-phone-numbers',
  templateUrl: './phone-numbers.component.html',
  styleUrls: ['./phone-numbers.component.scss']
})
export class PhoneNumbersComponent implements OnInit {
  type: string = '';
  pattern: string = '';
  phoneNumbers: any[] = [];
  loading: boolean = false;
  error: string = '';
  selectedNumber: any;

  constructor(private http: HttpClient,
    private jobService: JobService,
    private dialogRef: MatDialogRef<PhoneNumbersComponent>
  ) { }

  ngOnInit() {
    this.fetchPhoneNumbers()
  }

  fetchPhoneNumbers() {
    this.loading = true;
    this.error = '';
    this.phoneNumbers = [];

    this.jobService.fetchPlivoPhoneNumbers().subscribe({
      next: (response: any) => {
        console.log("response", response)
        this.phoneNumbers = response || [];
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to fetch phone numbers.';
        this.loading = false;
      }
    });
  }

  purchaseSelectedNumber() {
    if (!this.selectedNumber) return;

    const url = PURCHASE_PHONE_NUMBER;

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      'Content-Type': 'application/json'
    });

    const body = {
      countryCode: '+91',
      mobile: '+' + this.selectedNumber.number,
      plivoNumber: true
    };

    this.http.post(url, body, { headers }).subscribe({
      next: (res: any) => {
        if (res.subscriptionId) {
          const rzp = new Razorpay({
            key: environment.rezorpayKey,
            subscription_id: res.subscriptionId,
            name: 'Buy Phone Number',
            description: 'Subscription for Plivo phone number',
            handler: (response) => {
              //console.log('Payment successful:', response);
              this.activatePhoneNumber(res.subscriptionId, response);
            },
            modal: {
              ondismiss: () => {
                console.log('Razorpay popup closed');
              }
            }
          });
          rzp.open();
        } else {
          alert('No subscription ID returned from server.');
        }
      },
      error: (err) => {
        console.error('Error purchasing number:', err);
        alert('Failed to purchase the number.');
      }
    });
  }

  activatePhoneNumber(subscriptionId: string, paymentResponse: any) {
    const url = ACTIVATE_PHONE_NUMBER + '/' + subscriptionId;

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      'Content-Type': 'application/json'
    });

    const body = {
      razorpay_payment_id: paymentResponse.razorpay_payment_id,
      razorpay_subscription_id: paymentResponse.razorpay_subscription_id,
      razorpay_signature: paymentResponse.razorpay_signature
    };

    this.http.put(url, body, { headers }).subscribe({
      next: (res) => {
        console.log('Phone number activated successfully', res);
        // Close the popup and pass success data to parent
        this.cancel({ success: true, message: 'Phone number purchased and activated successfully!' });
      },
      error: (err) => {
        console.error('Activation failed', err);
        alert('Activation failed. Please contact support.');
        this.cancel({ success: false, message: 'Activation failed. Please contact support.' });
      }
    });
  }
  cancel(result?: any) {
    console.log('Cancel called with result:', result);
    this.dialogRef.close(result);
  }
}

